import { Box, Grid } from "@mui/material";
import React, { useContext } from "react";
import { RootStoreContext } from "../../store";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
// import style from "./Team_up.module.css";
import style from "./CompanyIntro.module.css";
import Stack from "@mui/material/Stack";
// import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import CustomSCBG from "../../components/button_group/CustomSCBG";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { createTeam } from "../../services/TeamService";
import { saveIntro } from "../../services/CompanyIntroService";
import { getAuth } from "firebase/auth";

const auth = getAuth();

const { useState } = React;
function CompanyIntro() {
  // const { TeamStore, PersonalStore } = useContext(RootStoreContext);
  const { CompanyIntroStore } = useContext(RootStoreContext);
  const { problem, solution, now, logo, slogan, feature, advantage, label1, label2, label1_percentage, label2_percentage, label1_illustration, label2_illustration } = CompanyIntroStore
  const { company1, company2, company3, company1_illustration, company2_illustration, company3_illustration } = CompanyIntroStore
  const { com_mode, financial_state, finstate1_year, finstate2_year } = CompanyIntroStore
  const { teamdata } = CompanyIntroStore
  const { updateData } = CompanyIntroStore;
  // const { teamname, field, ideation } = TeamStore;
  // const { updateData, updateMembers } = TeamStore;
  // const { username, profile_picture } = PersonalStore;
  // const [pos, setPos] = useState("");
  // const tmpUser = "Eric";

  const [LogoFile, setLogoFile] = useState();

  const selectFile = (event) => {
    setLogoFile(URL.createObjectURL(event.target.files[0]));
  };

  return (
    <Grid
      container
      className={style.main}
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Box className={style.box}>
        <Stack spacing={5}>
          <div>
            <Typography className={style.formTitle}>problem</Typography>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={style.problemTF}   //style.變數TF 待css檔完成
              value={problem}
              onChange={(e) => {
                updateData("problem", e.target.value);
              }}
            />
          </div>
          <div>
            <Typography className={style.formTitle}>solution</Typography>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={style.solutionTF}  //style.變數TF 待css檔完成
              value={solution}
              onChange={(e) => {
                updateData("solution", e.target.value);
              }}
            />
          </div>
          <div>
            <Typography className={style.formTitle}>Why now?</Typography>
            <TextField
              id="outlined-basic"
              variant="outlined"
              className={style.nowTF}
              value={now}
              onChange={(e) => {
                updateData("now", e.target.value);
              }}
            />
          </div>
          <div>
            <Typography className={style.formTitle}>公司資訊</Typography>
            <div>
              <Typography className={style.formTitle}>公司logo</Typography>
              {
                LogoFile ?
                  <div>
                    <button className="btn" onClick={() => { setLogoFile() }}>重新上傳</button>    {/*如果已經有LogoFile已經有檔案上傳的話*/}
                    <button className="btn submit">確定提交</button>
                  </div> :
                  <label className="btn">
                    <input type="file" style={{ display: "none" }} onChange={selectFile} />     {/*如果LogoFile還未有檔案上傳*/}
                    上傳公司logo
                  </label>
              }
            </div>
            <div>
              <Typography className={style.formTitle}>公司slogan</Typography>
              <TextField
                id="outlined-basic"
                placeholder="（一句話動人心弦，且簡單描述你們公司的話）"
                value={slogan}
                onChange={(e) => {
                  updateData("slogan", e.target.value);
                }}
                variant="outlined"
                className={style.sloganTF} />
            </div>
          </div>
          <div>
            <Typography className={style.formTitle}>產品服務特點</Typography>
            <TextField
              id="outlined-basic"
              multiline
              rows={3}
              value={feature}
              onChange={(e) => {
                updateData("feature", e.target.value);
              }}
              variant="outlined"
              className={style.featureTF}
            />
          </div>
          <div>
            <Typography className={style.formTitle}>產品服務優勢</Typography>
            <TextField
              id="outlined-basic"
              multiline
              rows={3}
              value={advantage}
              onChange={(e) => {
                updateData("advantage", e.target.value);
              }}
              variant="outlined"
              className={style.advantageTF}
            />
          </div>
          <div>
            <Typography className={style.formTitle}>市場分布</Typography>
            <div>
              <div>
                <Typography className={style.formTitle}>label1</Typography>
                <TextField
                  id="outlined-basic"
                  value={label1}
                  onChange={(e) => {
                    updateData("label1", e.target.value);
                  }}
                  variant="outlined"
                  className={style.label1TF}
                />
              </div>
              <div>
                <Typography className={style.formTitle}>label1_percentage</Typography>
                <TextField
                  id="outlined-basic"
                  value={label1_percentage}
                  onChange={(e) => {
                    updateData("label1_percentage", e.target.value);
                  }}
                  variant="outlined"
                  className={style.label1_percentageTF}
                />
              </div>
              <div>
                <Typography className={style.formTitle}>label1_illustration</Typography>
                <TextField
                  id="outlined-basic"
                  multiline
                  rows={3}
                  value={label1_illustration}
                  onChange={(e) => {
                    updateData("label1_illustration", e.target.value);
                  }}
                  variant="outlined"
                  className={style.label1_illustrationTF}
                />
              </div>
            </div>
            <div>
              <div>
                <Typography className={style.formTitle}>label2</Typography>
                <TextField
                  id="outlined-basic"
                  value={label2}
                  onChange={(e) => {
                    updateData("label2", e.target.value);
                  }}
                  variant="outlined"
                  className={style.label2TF}
                />
              </div>
              <div>
                <Typography className={style.formTitle}>label2_percentage</Typography>
                <TextField
                  id="outlined-basic"
                  value={label2_percentage}
                  onChange={(e) => {
                    updateData("label2_percentage", e.target.value);
                  }}
                  variant="outlined"
                  className={style.label2_percentageTF}
                />
              </div>
              <div>
                <Typography className={style.formTitle}>label2_illustration</Typography>
                <TextField
                  id="outlined-basic"
                  multiline
                  rows={3}
                  value={label2_illustration}
                  onChange={(e) => {
                    updateData("label2_illustration", e.target.value);
                  }}
                  variant="outlined"
                  className={style.label2_illustrationTF}
                />
              </div>
            </div>
          </div>
          <div>
            <Typography className={style.formTitle}>三個競爭者(首要、次要、第三)</Typography>
            <div>
              <div>
                <Typography className={style.formTitle}>首要競爭公司</Typography>
                <TextField
                  id="outlined-basic"
                  placeholder="（公司名稱）"
                  value={company1}
                  onChange={(e) => {
                    updateData("company1", e.target.value);
                  }}
                  variant="outlined"
                  className={style.company1TF}
                />
                <br />
                <TextField
                  id="outlined-basic"
                  multiline
                  rows={3}
                  value={company1_illustration}
                  placeholder="（首要競爭公司分析）"
                  onChange={(e) => {
                    updateData("company1_illustration", e.target.value);
                  }}
                  variant="outlined"
                  className={style.company1_illustrationTF}
                />
              </div>
              <div>
                <Typography className={style.formTitle}>次要競爭公司</Typography>
                <TextField
                  id="outlined-basic"
                  placeholder="（公司名稱）"
                  value={company2}
                  onChange={(e) => {
                    updateData("company2", e.target.value);
                  }}
                  variant="outlined"
                  className={style.company2TF}
                />
                <br />
                <TextField
                  id="outlined-basic"
                  multiline
                  rows={3}
                  value={company2_illustration}
                  placeholder="（次要競爭公司分析）"
                  onChange={(e) => {
                    updateData("company2_illustration", e.target.value);
                  }}
                  variant="outlined"
                  className={style.company2_illustrationTF}
                />
              </div>
              <div>
                <Typography className={style.formTitle}>第三競爭公司</Typography>
                <TextField
                  id="outlined-basic"
                  placeholder="（公司名稱）"
                  value={company3}
                  onChange={(e) => {
                    updateData("company3", e.target.value);
                  }}
                  variant="outlined"
                  className={style.company3TF}
                />
                <br />
                <TextField
                  id="outlined-basic"
                  multiline
                  rows={3}
                  value={company3_illustration}
                  placeholder="（第三競爭公司分析）"
                  onChange={(e) => {
                    updateData("company3_illustration", e.target.value);
                  }}
                  variant="outlined"
                  className={style.company3_illustrationTF}
                />
              </div>
            </div>
          </div>
          <div>
            <Typography className={style.formTitle}>商業模式</Typography>
            <TextField
              id="outlined-basic"
              multiline
              rows={3}
              value={com_mode}
              onChange={(e) => {
                updateData("com_mode", e.target.value);
              }}
              variant="outlined"
              className={style.com_modeTF}
            />
          </div>
          <div>
            <Typography className={style.formTitle}>財務報表</Typography>
            <TextField
              id="outlined-basic"
              multiline
              rows={3}
              placeholder="（財務報表描述）"
              value={financial_state}
              onChange={(e) => {
                updateData("financial_state", e.target.value);
              }}
              variant="outlined"
              className={style.financial_stateTF}
            />
            <div>
              <Typography className={style.formTitle}>Financial statement</Typography>
              <div>
                <Typography className={style.formTitle}>第一年到第五年之資產</Typography>
                <TextField
                  id="outlined-basic"
                  placeholder="（num1, num2,...）"
                  value={finstate1_year}                                                  //input five num
                  onChange={(e) => {
                    updateData("finstate1_year", e.target.value);
                  }}
                  variant="outlined"
                  className={style.finstate1_year1TF}
                />
              </div>
              <div>
                <Typography className={style.formTitle}>第一年到第五年之現金流</Typography>
                <TextField
                  id="outlined-basic"
                  placeholder="（num1, num2,...）"
                  value={finstate2_year}                                                    //input five num
                  onChange={(e) => {
                    updateData("finstate2_year", e.target.value);
                  }}
                  variant="outlined"
                  className={style.finstate1_year1TF}
                />
              </div>
            </div>
          </div>
          <div>
            <Typography className={style.formTitle}>團隊資料</Typography>
            <TextField
              id="outlined-basic"
              multiline
              rows={5}
              value={teamdata}
              onChange={(e) => {
                updateData("teamdata", e.target.value);
              }}
              variant="outlined"
              className={style.teamdataTF}
            />
          </div>
          {/*<div>
            <Typography className={style.formTitle}>團隊領域</Typography>   //下拉式選單
            <FormControl className={style.selectField}>
                {/* <InputLabel id="demo-simple-select-helper-label">
                    團隊領域
                </InputLabel> */}
          {/*<Select
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                value={field}
                // label="Field"
                onChange={(e) => {
                  updateData("field", e.target.value);
                }}
              >
                {fieldList.map((item) => (
                  <MenuItem value={item}>{item}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>*/}
          {/* <div>
            <Typography className={style.formTitle}>職位選擇</Typography>
            <Box mt={2}>
              <CustomSCBG
                buttons={["執行長", "行銷長", "技術長", "財務長", "設計長"]}
                onChange={(item) => {
                  let members = [
                    { title: "CEO", name: "", img: "", id: "" },        //members存一開始創隊的人選擇的職位，並將其個人資料填入此職位之中
                    { title: "CTO", name: "", img: "", id: "" },
                    { title: "CMO", name: "", img: "", id: "" },
                    { title: "CFO", name: "", img: "", id: "" },
                    { title: "CDO", name: "", img: "", id: "" },
                  ];
                  for (let i = 0; i < members.length; i++) {
                    if (item === members[i].title) {
                      members[i].name = username;
                      members[i].img = profile_picture;
                      members[i].id = auth.currentUser.uid;
                    }
                  }
                  console.log(members);
                  setPos(item);
                  // updateMembers(members);
                  updateData("members", members);
                }}
                extraInfo={tmpUser}
              />
            </Box>
          </div> */}
        </Stack>
        <Box mt={13}>
          <Stack direction="row" justifyContent="flex-end" spacing={2}>
            <Link to={"/Teamformation"}>
              <button className={style.cancelBtn}>取消</button>            {/*  //最後submit出去和取消回到"組建團隊"頁面 */}
            </Link>
            <Link to={"/team-1"}>
              <button
                className={style.submitBtn}
                onClick={(e) => {
                  saveIntro({
                    // teamname: teamname,
                    // field: field,
                    // ideation: ideation,
                    // position: pos,
                    problem: problem,
                    solution: solution,
                    now: now,
                    slogan: slogan,
                    feature: feature,
                    advantage: advantage,
                    label1: label1,
                    label2: label2,
                    label1_percentage: label1_percentage,
                    label2_percentage: label2_percentage,
                    label1_illustration: label1_illustration,
                    label2_illustration: label2_illustration,
                    company1: company1,
                    company2: company2,
                    company3: company3,
                    company1_illustration: company1_illustration,
                    company2_illustration: company2_illustration,
                    company3_illustration: company3_illustration,
                    com_mode: com_mode,
                    financial_state: financial_state,
                    finstate1_year: finstate1_year,
                    finstate2_year: finstate2_year,
                    teamdata: teamdata,
                  });
                }}
              >
                儲存公司資料
              </button>
            </Link>
          </Stack>
        </Box>
      </Box>
    </Grid>
  );
}

export default observer(CompanyIntro);
